<template lang="pug">
  div(
    v-if="user"
    class="profile-wrapper"
  )
    div(class="profile__content")
      h4(class="text-16px medium dark mb-4") {{ $t('My data') }}
      div(class="profile__item")
        div(class="profile__item-name text-14px") {{ $t('Full name') }}
        div(class="profile__item-value text-14px dark") {{ user.name ? user.name : '-' }}
        div(class="profile__item-action")
          v-btn(
            class="secondary-button profile__item-btn"
            @click="changeUserName"
          ) {{ $t('Change') }}
      div(class="profile__item")
        div(class="profile__item-name text-14px") {{ $t('Email (login)') }}
        div(class="profile__item-value text-14px dark") {{ user.login }}
        div(class="profile__item-action")
          v-btn(
            class="secondary-button profile__item-btn"
            @click="changeEmail"
          ) {{ $t('Change') }}
</template>

<script>
import User from '~/models/administration/User'
import contentDialog from '~/mixins/dialogs/contentDialog'
import informationDialog from '~/mixins/dialogs/informationDialog'
import mobileDrawer from '~/modules/mobile-drawer/mixins/mobileDrawer'
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'BlockProfileData',
  mixins: [contentDialog, informationDialog, mobileDrawer, responsive],
  computed: {
    user() {
      return User.query().where('id', this.$User.id).first()
    }
  },
  methods: {
    async changeUserName() {
      const isChanged = await this.contentDialog.open({
        component: 'form-change-name',
        width: '512px',
        componentProps: {
          currentName: this.user.name
        }
      })
      if (isChanged) {
        await this.informationDialog.open({
          title: this.$t('Full name are successfully updated'),
          text: this.$t('You always can change full name in "Settings"'),
          textClass: 'text-center',
          width: '512px'
        })
      }
    },
    async changeEmail() {
      // todo: make generic component for modals display on different devices
      let isEmailChanged
      if (this.xsDevice) {
        isEmailChanged = await this.mobileDrawer.open({
          component: 'm-change-email'
        })
      } else {
        isEmailChanged = await this.contentDialog.open({
          component: 'm-change-email',
          width: '512px'
        })
      }
      if (isEmailChanged) {
        await this.informationDialog.open({
          width: '512px',
          image: require('~/assets/images/check-mark.gif'),
          title: this.$t('Email changed'),
          text: this.$t('Now you can use new email for getting mails'),
          textClass: 'text-14px fw-300',
          buttonText: this.$t('Understand')
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.profile {
  &-wrapper {
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 16px;
  }

  &__content {
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__item {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    width: 100%;
    height: 72px;

    background: rgba(0, 0, 0, 0.03);
    border-radius: 12px;

    padding: 16px;

    @media (max-width: map-get($breakpoints, 'sm')) {
      height: auto;
    }

    &-name {
      flex-basis: 15%;

      @media (max-width: map-get($breakpoints, 'sm')) {
        flex-basis: 100%;
      }
    }

    &-value {
      flex-grow: 1;

      @media (max-width: map-get($breakpoints, 'sm')) {
        flex-basis: 100%;
        padding: 5px 0 10px 0;
      }
    }

    &-action {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-basis: 10%;

      @media (max-width: map-get($breakpoints, 'sm')) {
        flex-basis: 100%;
      }
    }

    &-btn {
      height: 40px !important;
    }
  }
}
</style>
